// extracted by mini-css-extract-plugin
export default {"input-wrapper":"input-password_input-wrapper__ghMNR","toggle-button":"input-password_toggle-button__KuvMW"};